//@ts-nocheck
import { Box, Typography, Button, Grid, CardMedia } from '@mui/material';
import '../../../../styles/customScrollbar.css';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { Avatar, Chip, Link as MuiLink, IconButton } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkIcon from '@mui/icons-material/Link';
import CommonCardData from 'modules/Discover/components/DiscoverData/CommonCardData';
import { cousresArray } from 'constant/data';
import { useEffect, useState } from 'react';
import { UserService } from 'services/UserService';
import { ContentsService } from 'services/ContentsService';
import { Content } from 'types';

interface UserData {
  firstName: string;
  lastName: string;
  profileUrl: string;
  licenseNumber: string;
  type: string;
  certifications: [];
  biography: string;
  linkedin: string;
  instagram: string;
  [key: string]: any;
}

const ProfileViewData = () => {
  const navigate = useNavigate();
  const [showAll, setShowAll] = useState(false);
  const { state } = useLocation();
  const { userId } = useParams(); // Get userId from the route
  const [userData, setUserData] = useState<UserData | null>(null);
  const [userContents, setUserContents] = useState<Content[]>([]);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const data = await UserService.getUserByid(userId!);
        setUserData(data);
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    const fetchUserContents = async () => {
      try {
        const contents = await ContentsService.getContentsByUserId(userId!);
        setUserContents(contents); // No type error now
      } catch (error) {
        console.error('Error fetching user contents:', error);
      }
    };

    fetchUserData();
    fetchUserContents();

    if (state && state.userContents) {
      setUserContents(state.userContents);
    }
  }, [userId, state]);

  const handleBack = () => {
    navigate(-1);
  };

  const handleSeeAllClick = () => {
    setShowAll(true);
  };

  if (!userContents) {
    return <div>Loading...</div>;
  }

  return (
    <Box sx={styleSheet.mainContainer}>
      <Box onClick={handleBack} sx={styleSheet.headerContainer}>
        <KeyboardArrowLeftIcon sx={{ color: '#233F91', fontSize: '28px' }} />
        Content Information
      </Box>
      <Box sx={styleSheet.cardContainer}>
        <Box position={'relative'}>
          <Box sx={styleSheet.header}></Box>
          <Box
            display='flex'
            flexDirection={{ xs: 'column', md: 'row' }}
            alignItems='center'

            px={{ xs: 0, md: 7 }}>
            <Box>
              <CardMedia
                component='img'
                sx={styleSheet.proImage}
                image={userData?.profileUrl || '/assets/icons/profileView.png'}
                alt={'profile'}
              />
            </Box>
            <Box sx={styleSheet.proContainer}>
              <Box
                display={'flex'}
                alignItems={'center'}
                gap={{ xs: 1, md: 3 }}>
                <Typography
                  fontWeight='400'
                  fontSize={{ xs: '12.62px', md: '22px' }}
                  ml={'10px'}>
                  {userData?.firstName} {userData?.lastName}
                </Typography>
                <Typography
                  fontWeight='400'
                  fontSize={{ xs: '9.75px', md: '17px' }}
                  color='#797979'>
                  she/her/hers
                </Typography>
                <Chip label={userData?.type} sx={styleSheet.contentBtn} />
              </Box>

              <Box display='flex' alignItems='center'>
                <IconButton
                  component={MuiLink}
                  href='#'
                  sx={styleSheet.iconButton}>
                  <CardMedia
                    component='img'
                    sx={{
                      width: { xs: 15, md: 28 },
                      height: { xs: 15, md: 28 },
                    }}
                    image={'/assets/icons/iconLinkedin.png'}
                    alt={'linkedIn'}
                  />
                </IconButton>
                <IconButton
                  component={MuiLink}
                  href='#'
                  sx={styleSheet.iconButton}>
                  <CardMedia
                    component='img'
                    sx={{
                      width: { xs: 15, md: 27 },
                      height: { xs: 15, md: 27 },
                    }}
                    image={'/assets/icons/iconIntagram.png'}
                    alt={'intagram'}
                  />
                </IconButton>
                <IconButton
                  component={MuiLink}
                  href='#'
                  sx={styleSheet.iconButton}>
                  <CardMedia
                    component='img'
                    sx={{
                      width: { xs: 15, md: 23 },
                      height: { xs: 15, md: 23 },
                    }}
                    image={'/assets/icons/iconLink.png'}
                    alt={'sharedLink'}
                  />
                </IconButton>
              </Box>
            </Box>
            <Box
              ml={{ xs: '200px', md: 'auto' }}
              textAlign='right'
              display='flex'
              gap={3}
              alignItems='center'
              mt={{ xs: '-24px', md: '63px' }}>
              <Typography
                fontWeight='700'
                color={'#595959'}
                fontSize={{ xs: '12.04px', md: '20.98px' }}>
                License Number
              </Typography>
              <Typography
                variant='body2'
                fontWeight='400'
                mr={{ xs: 1, md: 0 }}
                fontSize={{ xs: '9.75px', md: 17 }}
                color={'#797979'}>
                {userData?.licenseNumber || 'N/A'}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box sx={styleSheet.container}>
        <Box>
          <Box sx={styleSheet.textContainer}>
            <Box
              display={'flex'}
              flexDirection={{ xs: 'column', md: 'row' }}
              gap={{ xs: 1, md: 10 }}
              px={{ xs: 2, md: 6 }}>
              <Typography sx={styleSheet.BottomHeaderText}>
                Biography
              </Typography>
              <Box display={'flex'} flexDirection={'column'}>
                <Typography sx={styleSheet.text}>
                  {userData?.biography}
                </Typography>
              </Box>
            </Box>
            <Box
              display={'flex'}
              flexDirection={{ xs: 'column', md: 'row' }}
              gap={{ xs: 1, md: 6 }}
              px={{ xs: 2, md: 6 }}>
              <Typography sx={styleSheet.BottomHeaderText}>
                Certifications
              </Typography>
              <Box display={'flex'} flexDirection={'column'} gap={3}>
                {Array.isArray(userData?.certifications) &&
                  userData.certifications.length > 0 ? (
                  userData.certifications.map(
                    (cert: { certification: string }, index: number) => (
                      <Typography key={index} sx={styleSheet.text}>
                        {cert.certification}
                      </Typography>
                    )
                  )
                ) : (
                  <Typography sx={styleSheet.text}>
                    No certifications available.
                  </Typography>
                )}
              </Box>

              {/* <Box display={"flex"} flexDirection={"column"} gap={3}>
                <Typography sx={styleSheet.text}>
                  {userData?.certifications?.map((cert: string) => (
                    <Typography sx={styleSheet.text}>{cert}</Typography>
                  ))}
                </Typography>
                
              </Box> */}
            </Box>
            <Box
              display={'flex'}
              overflow={'hidden'}
              flexDirection={'column'}
              gap={2}
              px={{ xs: 2, md: 6 }}>
              <Typography sx={styleSheet.BottomHeaderText}>Contents</Typography>

              <Grid
                container
                spacing={4}
                flexWrap={{ xs: 'nowrap', md: 'wrap' }}
                overflow={{ xs: 'auto', md: 'visible' }}
                sx={{
                  scrollbarWidth: 'none', // Hide scrollbar on Firefox
                  '&::-webkit-scrollbar': { display: 'none' }, // Hide scrollbar on Chrome, Safari, and Edge
                }}>
                {(showAll
                  ? Array.isArray(userContents)
                    ? userContents
                    : []
                  : Array.isArray(userContents)
                    ? userContents.slice(0, 6)
                    : []
                ).map((item: any, index: number) => (
                  <Grid
                    item xs={12} width={'100%'} md={4}
                    mb={{ xs: 2, md: 2 }}
                    key={index}
                  >
                    <CommonCardData
                      title={item.title}
                      category={item.category}
                      summary={item.summary}
                      author={
                        userData?.firstName + ' ' + (userData?.lastName || '')
                      }
                      createdAt={item.updatedAt}
                      sourceOfKnowledge={item.sourceOfKnowledge}
                      type={item.type}
                      price={item.price}
                      coverPhotoUrl={item.coverPhotoUrl}
                      profilePicture={
                        userData?.profileUrl ||
                        '/assets/icons/defaultProfile.png'
                      }
                      onClick={() => navigate(`/discover/${item.id}`)}
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>

            <Box></Box>
          </Box>
        </Box>

        <Box
          display={'flex'}
          justifyContent={{ xs: 'start', md: 'center' }}
          mt={5}
          pb={{ xs: 5, md: 0 }}
          ml={{ xs: 2, md: 0 }}>
          {/* Conditional rendering for "See More" button */}
          {Array.isArray(userContents) &&
            userContents.length > 6 &&
            !showAll && (
              <Button
                onClick={handleSeeAllClick}
                variant='contained'
                sx={styleSheet.btnPurchase}>
                See More
              </Button>
            )}
        </Box>
      </Box>
    </Box>
  );
};

export default ProfileViewData;

const styleSheet = {
  mainContainer: {
    p: { xs: 0, md: 5 },
  },
  container: {
    margin: 'auto',
    padding: { xs: '0px', md: '40px' },
    border: '1px solid #ccc',
    borderRadius: '15px',
    backgroundColor: '#fff',
    boxShadow: '0px 0px 10px rgba(0,0,0,0.1)',
    marginTop: '24px',
  },
  headerContainer: {
    pt: { xs: 15, md: 3 },
    pb: 3,
    fontWeight: 500,
    fontSize: '28px',
    color: '#233F91',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  proContainer: {
    ml: { xs: '100px', md: 24 },
    mt: { xs: 1, md: 3 },
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: 0, md: 1 },
  },
  boxContainer: {
    display: 'flex',
    gap: 5,
    marginBottom: '16px',
    borderRadius: '8px 8px 0 0',
  },
  btnPsychotherapy: {
    bgcolor: '#00A79D',
    color: '#EDEDED',
    borderRadius: '15px',
    fontSize: '12px',
    width: '106.81px',
    height: '20px',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    mt: 2,
  },
  text: {
    fontWeight: 400,
    fontSize: 17,
    color: '#797979',
    lineHeight: '24px',
    letter: '-1%',
    // width: "739px"
  },
  btnPurchase: {
    bgcolor: '#233F91',
    color: '#fff',
    borderRadius: '15px',
    fontSize: '12px',
    width: '105px',
    height: '48px',
  },

  contentBtn: {
    mt: 1,
    fontSize: { xs: '10px', md: '18px' },
    fontWeight: 700,
    color: '#11B981',
    background: '#CFF1E6',
  },
  iconFont: {
    width: '26.45px',
    height: '26.45px',
  },

  BottomHeaderText: {
    fontWeight: 700,
    fontSize: '20.98px',
    color: '#595959',
  },

  cardContainer: {
    border: '1px solid #ddd',
    borderRadius: '8px',
    overflow: 'hidden',
    margin: 'auto',
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
    background: '#fff',
    height: '248px',
    position: 'relative',
    // margingBottom: '20px',
  },
  header: {
    background: 'linear-gradient(to bottom, #00A79D, #00A79D, #F9ED32)',
    height: '86.75px',
  },
  iconButton: {
    color: '#233F91',

    '&:hover': {
      color: '#1a237e',
    },
  },

  proImage: {
    position: 'absolute',
    top: { xs: 70, md: 50 },
    left: { xs: 20, md: 70 },
    width: { xs: 80, md: 167 },
    height: { xs: 80, md: 167 },
    borderRadius: '50%',
  },
};
